<div class="flex place-content-center m-2 lg:m-4">
  @for (digit of tokenCharArray(); track digit) {
    <div
      class="bg-[var(--faculty-200,platform-200)] rounded-md py-1.5 sm:py-3 lg:py-5 px-2 sm:px-3.5 lg:px-4 mx-1.5 sm:mx-2 lg:mx-3"
    >
      <span class="text-[var(--faculty-600,platform-600)] text-3xl sm:text-4xl lg:text-6xl font-bold">{{ digit }}</span>
    </div>
  }
</div>
